import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { HISTORY_TYPE } from '../type/types';

interface postOrderCompleteProps {
  orderId: string;
}

// 주문 완료
export const postOrderComplete = async ({
  orderId,
}: postOrderCompleteProps) => {
  const res = await api.post<ApiResponseType<HISTORY_TYPE>>(
    '/api/web/partners/orders/complete',
    orderId
  );
  return res.data;
};
